import { createSlice } from "@reduxjs/toolkit";

const globalSlice = createSlice({
  name: "global",
  initialState: {
    changePasswordModal: false,
    addModal: false,
    addModalData: null,
    updateModal: false,
    updateId: null,
    assignModal: false,
    assignId: null,
    bool: false,
    filter: false,
    sosModal: false,
    guardSosModal: false,
  },
  reducers: {
    toggleChangePasswordModal: (state) => {
      state.changePasswordModal = !state.changePasswordModal;
    },
    toggleAddModal: (state, action) => {
      const next = !state.addModal;
      state.addModal = next;
      state.addModalData = next ? (action?.payload ?? null) : null;
    },
    toggleUpdateModal: (state, action) => {
      state.updateId = action?.payload?.id
      state.updateModal = !state.updateModal;  // Toggle show state
    },
    toggleAssignModal: (state, action) => {
      state.assignId = action?.payload?.id ?? null;
      state.assignModal = !state.assignModal;
    },
    toggleBool: (state) => {
      state.bool = !state.bool;  // Toggle bool state
    },
    toggleFilter: (state) => {
      state.filter = !state.filter;  // Toggle bool state
    },
    closeFilter: (state) => {
      state.filter = false;
    },
    toggleSosModal: (state) => {
      state.sosModal = !state.sosModal;
    },
    toggleGuardSosModal: (state) => {
      state.guardSosModal = !state.guardSosModal;
    },
  },
});

// Export actions
export const { toggleChangePasswordModal, toggleAddModal, toggleUpdateModal, toggleAssignModal, toggleBool, toggleFilter, closeFilter, toggleSosModal, toggleGuardSosModal } = globalSlice.actions;

// Export reducer
export default globalSlice.reducer;